import {
  Box,
  Button,
  Checkbox,
  Flex,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { api } from "../../../../service/api";
import { useEffect, useState } from "react";
import { formatCurrency } from "../../../../utils/utils";

export interface ProductsInfo {
  id: number;
  product_furnisher_id: string;
  is_check: boolean;
  is_disable: boolean;
  product_name: string;
  unit: string;
  quantity: string;
  price: number;
  discount: number;
  new_price: number;
}

type Props = {
  discount: number;
  officeId: string;
  callBackSuccess: (data: ProductsInfo[]) => void;
};

export function FormTableProducts({
  discount,
  officeId,
  callBackSuccess,
}: Props) {
  const toast = useToast();

  const [newProducts, setNewProducts] = useState<ProductsInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [allChecked, setAllChecked] = useState(false);

  async function getProducts(discount: number, officeId: string) {
    try {
      setLoading(true);
      const response = await api.get("contract/product/list/" + officeId);
      updateInfoProducts(response.data, discount);
    } catch (error) {
      toast({
        position: "top-right",
        title: "Produto",
        description: "Não foi possível carregar os produtos.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function updateInfoProducts(producs: any, discount: number) {
    const ProductsInfo: ProductsInfo[] = [];

    for (let index = 0; index < producs.length; index++) {
      const product = producs[index];

      let calcDiscount = (discount / 100) * -1;
      let newPrice = product.price * (1 + calcDiscount);

      let is_disable =
        product.produc_contract && product.produc_contract.id ? true : false;

      ProductsInfo.push({
        id: index,
        product_furnisher_id: product.id,
        is_check: false,
        product_name: product.name,
        quantity: product.quantity,
        price: product.price,
        unit: product.unit,
        discount: discount,
        new_price: newPrice,
        is_disable: is_disable,
      });
    }

    setNewProducts(ProductsInfo);
  }

  function updatelChecked(
    is_all: boolean,
    is_check: boolean,
    item?: ProductsInfo
  ) {
    const ProductsInfo: ProductsInfo[] = [];

    for (let index = 0; index < newProducts.length; index++) {
      const product = newProducts[index];

      ProductsInfo.push({
        product_furnisher_id: product.product_furnisher_id,
        id: product.id,
        is_check: product.is_disable
          ? false
          : is_all
          ? is_check
          : product.id === item?.id
          ? is_check
          : product.is_check,
        product_name: product.product_name,
        quantity: product.quantity,
        price: product.price,
        unit: product.unit,
        discount: product.discount,
        new_price: product.new_price,
        is_disable: product.is_disable,
      });
    }

    setNewProducts(ProductsInfo);
  }

  function sendTablePrice() {
    const isSelectedData = newProducts.filter((e) => e.is_check === true);
    if (isSelectedData.length === 0) {
      toast({
        position: "top-right",
        title: "Produto",
        description: "Selecione um produto para continuar",
        status: "info",
        duration: 9000,
        isClosable: true,
      });

      return;
    }

    callBackSuccess(isSelectedData);
  }

  useEffect(() => {
    getProducts(discount, officeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discount, officeId]);

  useEffect(() => {
    const isAllCheck = newProducts.find((e) => e.is_check === false);
    setAllChecked(!isAllCheck);
  }, [newProducts]);

  return (
    <Flex flexDirection="column" width="1000px">
      <Box px={10} py={5} borderRadius={8} height={400}>
        {loading && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={400}
          >
            <Spinner
              color="green.600"
              emptyColor="white"
              thickness="4px"
              size="xl"
              h={100}
              w={100}
            />
          </Box>
        )}
        {!loading && (
          <TableContainer>
            <Table variant="striped" colorScheme="gray" size="sm">
              <Thead>
                <Tr bg="green.600" height="10">
                  <th>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="40px"
                    >
                      <Checkbox
                        size="lg"
                        colorScheme="green"
                        isChecked={allChecked}
                        onChange={(e) => {
                          updatelChecked(true, e.target.checked);
                          setAllChecked(e.target.checked);
                        }}
                      />
                    </Box>
                  </th>
                  <Th color="white">NOME COMERCIAL</Th>
                  <Th color="white" textAlign="center">
                    UND
                  </Th>
                  <Th color="white" textAlign="center">
                    QUANTIDADE
                  </Th>
                  <Th color="white" textAlign="center">
                    PREÇO ATUAL
                  </Th>
                  <Th color="white" textAlign="center">
                    % DE DESCONTO
                  </Th>
                  <Th color="white" textAlign="center">
                    NOVO PREÇO
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {newProducts.map((item, index) => (
                  <Tr key={index}>
                    <td>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        width="40px"
                      >
                        <Checkbox
                          size="lg"
                          colorScheme="green"
                          isChecked={item.is_check}
                          onChange={(e) => {
                            updatelChecked(false, e.target.checked, item);
                          }}
                        />
                      </Box>
                    </td>
                    {item.is_disable ? (
                      <Td>
                        <Tooltip
                          label="Produto esta em uso em outro contrato para esse mesmo cliente."
                          aria-label="A tooltip"
                        >
                          <Text as="del">{item.product_name}</Text>
                        </Tooltip>
                      </Td>
                    ) : (
                      <Td>{item.product_name}</Td>
                    )}
                    <Td textAlign="center">{item.unit}</Td>
                    <Td textAlign="center">
                      {formatCurrency(Number(item.quantity))}
                    </Td>
                    <Td textAlign="center">R$ {formatCurrency(item.price)}</Td>
                    <Td textAlign="center">{formatCurrency(item.discount)}%</Td>
                    <Td textAlign="center">
                      R$ {formatCurrency(item.new_price)}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Box>
      {!loading && (
        <Box px={10} mb={10} alignSelf="flex-end">
          <Button
            type="submit"
            bg="green.600"
            color="white"
            alignSelf="flex-end"
            height={10}
            _hover={{
              bg: "green.800",
            }}
            mt="6"
            size="lg"
            onClick={sendTablePrice}
          >
            Continuar
          </Button>
        </Box>
      )}
    </Flex>
  );
}
